export class LanguageModel {
    constructor(public Id: number, public Name: string, public ShortName: string, public Flag: string) {

    }
}